define('view/helper/TemplateHelper',['require','lib/view/BaseTemplateHelper','handlebars','lib/view/BookingUrlBuilder','lib/theme/ThemeSettings','Config'],function (require) {

    require('lib/view/BaseTemplateHelper');

    var Handlebars = require('handlebars');
	var BookingUrlBuilder = require('lib/view/BookingUrlBuilder');
    var ThemeSettings = require('lib/theme/ThemeSettings');
    var Config = require('Config');




    /**
     * Checks if plugin is active
     *
     * @param String plugin
     */
    Handlebars.registerHelper('ifPluginActive', function(plugin, options) {
        var plugins = Config.getInstance().getOption('plugins');

        if (!_.isFunction(options.fn)) { // to make possible to call it iside of other functions e.g.: {{>form_phone name="phone" required=(ifPluginActive 'hipaa') ... }}
            return plugins[plugin] && parseInt(plugins[plugin].is_active);
        }

        if (plugins[plugin] && parseInt(plugins[plugin].is_active)) {
            return options.fn(this);
        }
        return options.inverse(this);
    });

	/**
	 * Helper builds booking url
	 *
	 * @param String param - additional param name
	 * @param mixed value - additional param value
	 * @return String
	 */
	Handlebars.registerHelper('bookingStepUrl', function(options) {
	    if (options.hash.categories && !options.hash.category) {
            options.hash.category = _.first(options.hash.categories);
        }
		return BookingUrlBuilder.getInstance().buildUrl('booking_step', options.hash);
	});

    

    Handlebars.registerHelper('getUniqueId', function(options) {
        var prefix = 'sb_uniq_id_';

        if (!_.isUndefined(options.hash) && !_.isUndefined(options.hash.prefix)) {
            prefix = options.hash.prefix;
        }
        return _.uniqueId(prefix);
    });

    Handlebars.registerHelper('setVariable', function(varName, varValue, isArray, options) {
        if(isArray && !_.isObject(isArray)){
            varValue = eval(varValue);
        }
        this[varName] = varValue;
    });


    /**
     * Returns image path by image name in theme settings
     *
     * @param String image
     * @param Object options
     * @return String
     */
    Handlebars.registerHelper('getThemeImage', function(image, options) {
        var themeSettings = ThemeSettings.getInstance();

        var result = themeSettings.getOption(image + '_preview');

        if (options.hash && options.hash.size) {
            result = result.replace('/preview/', '/' + options.hash.size + '/');
        }
        return result;
    });

    Handlebars.registerHelper('hasThemeImage', function(image, options) {
        var themeSettings = ThemeSettings.getInstance();
        var result = themeSettings.getOption(image + '_preview');
        if (result) {
            return options.fn(this);
        }
        return options.inverse(this);
    });

    /**
     * Returns Image mode by image name in theme settings
     *
     * @param String image
     * @return String
     */
    Handlebars.registerHelper('getThemeImageMode', function(image, options) {
        return ThemeSettings.getInstance().getOption(image + '_mode');
    });

    Handlebars.registerHelper('getThemeImageBackgroundMode', function(image, options) {
        var mode = ThemeSettings.getInstance().getOption(image + '_mode');
        var position = ThemeSettings.getInstance().getOption(image + '_position');
        
        var result = '';
        if (mode === 'cover') {
            result += 'background-size: cover;';
        } else {
            result += 'background-size: auto; background-repeat: ' + mode + ';';
        }
        
        result += 'background-position: ' + position + ';'; 
        
        return result;
    });

    Handlebars.registerHelper('getThemeOption', function(key, options) {
        return ThemeSettings.getInstance().getOption(key);
    });

    Handlebars.registerHelper('formatAvatarImage', function(url, options) {
        if (!url) {
            if (options.hash && options.hash.defaultImage) {
                return options.hash.defaultImage;
            }
            return '/v2/themes/assets/img/user-default-image.png';
        }
        var size = '100';
        if (options.hash.size) {
            size = options.hash.size;
        }
        if (url.indexOf('facebook') !== -1) {
            return url + '?width=' + size + '&height=' + size;
        }
        if (url.indexOf('twimg') !== -1) {
            return url.replace('_normal', '');
        }
        if (url.indexOf('google') !== -1) {
            return url.replace('sz=50', 'sz=' + size);
        }
        return url;
    });

    Handlebars.registerHelper('invoiceLineLink', function(line, options) {
        switch (line.type) {
            case 'booking':
                return '#client/bookings/type/all/highlight/' + line.booking_ids;
            case 'membership':
                return '#membership/my/highlight/' + line.membership_id;
            case 'promotion':
                // @todo it seems we do not have instance id?
                return '#gift-card/my/highlight/' + line.promotion_instance_id;
            default:
                return null;
        }
    });


    Handlebars.registerHelper('formatDuration', function(duration, options) {
        var type = 'time';
        if (options.hash && options.hash.type) {
            type = options.hash.type;
        }

        switch (type) {
            case 'year':
            case 'month':
            case 'week':
            case 'day':
                duration = parseInt(duration);
                if (duration === 1) {
                    return duration + ' ' + Locale.get(type);
                }
                var lastDigit = Math.abs(duration % 10);
                var preLastDigit = Math.abs(Math.round(duration / 10) % 10);
                if (lastDigit === 1 && preLastDigit !== 1) {
                    return duration + ' ' + Locale.get('x1_' + type + 's');
                }
                if (lastDigit > 1 && lastDigit < 5 && preLastDigit !== 1) {
                    return duration + ' ' + Locale.get('2_3_4_' + type + 's');
                }
                return duration + ' ' + Locale.get(type + 's');
            default:
                var hours = Math.floor(duration / 60);
                var minutes = duration - (hours * 60);

                var result = '';
                if (hours) {
                    result += hours + ' ' + Locale.get('hr.');
                }
                if (minutes) {
                    if (result.length) {
                        result += ' ';
                    }
                    result += minutes + ' ' + Locale.get('mins.');
                }
                return result;
        }
    });

    Handlebars.registerHelper('baseUrl', function(key, options) {
        // temporary return '/v2', later we will not use it.
        return '/v2';
    });


    Handlebars.registerHelper('placeholder', function(str, options) {
        _.each(options.hash, function (value, key) {
            str = str.replace(':' + key, value);
        });
        return str;
    });

    Handlebars.registerHelper('findInArray', function(value, options) {
        if (options.hash.options) {
            var field = 'id';
            if (options.hash.field) {
                field = options.hash.field;
            }

            var filter = {};
            filter[field] = value;

            var index = _.findIndex(options.hash.options, filter);
            if (index >= 0) {
                return options.fn(options.hash.options[index]);
            } else {
                return options.inverse(this);
            }
        }
    });

    Handlebars.registerHelper('forEach', function(context, as, param, options) {
        var ret = "";
        for(var i=0, j=context.length; i<j; i++) {
            var data = {};
            data[param] = context[i];

            ret = ret + options.fn(_.extend(data, this));
        }
        return ret;
    });

    Handlebars.registerHelper('for', function(options) {
        if (!options.hash) {
            options.hash = {};
        }
        var from = options.hash.from || 1;
        var to = options.hash.to || 1;
        var step = options.hash.step || 1;

        var ret = "";
        for(var i = from; i <= to; i += step) {
            ret = ret + options.fn(_.extend({'_currentIndex': i}, this));
        }
        return ret;
    });


    Handlebars.registerHelper('mapIframe', function(options) {
        var mapKey = Config.getInstance().getOption('map_key');
        var lat = options.hash.lat;
        var lng = options.hash.lng;
        var address = options.hash.address;

        switch (Config.getInstance().getOption('map_type')) {
            case 'amap':
                if (address) {
                    return '/v2/js/maps/amap/iframe.php?key='+mapKey+'&address='+address;
                } else {
                    return '/v2/js/maps/amap/iframe.php?key='+mapKey+'&lat='+lat+'&lng='+lng;
                }
                break;
            case 'osm':
                if (address) {
                    return '/v2/js/maps/leaflet/iframe.php?address='+address;
                } else {
                    return '/v2/js/maps/leaflet/iframe.php?lat='+lat+'&lng='+lng;
                }
                break;
            case 'vector':
                if (address) {
                    return '/v2/js/maps/vector/iframe.php?address='+address;
                } else {
                    return '/v2/js/maps/vector/iframe.php?lat='+lat+'&lng='+lng;
                }
                break;

            default:
                if (address) {
                    return 'https://www.google.com/maps/embed/v1/place?key='+mapKey+'&q='+address;
                } else {
                    return 'https://www.google.com/maps/embed/v1/place?key='+mapKey+'&q='+lat+','+lng;
                }
        }
    });

    Handlebars.registerHelper('mapLink', function(options) {
        var mapKey = Config.getInstance().getOption('map_key');
        var lat = options.hash.lat;
        var lng = options.hash.lng;
        var address = options.hash.address;

        switch (Config.getInstance().getOption('map_type')) {
            case 'amap':
                if (address) {
                    return 'http://ditu.amap.com/search?query='+encodeURIComponent(address);
                } else {
                    //TODO check if displayed correctly; see http://lbs.amap.com/api/uri-api/guide/mobile-web/point for docs
                    return 'http://uri.amap.com/marker?position='+lng+','+lat+'&name='+lng+','+lat+'&src=simplybook&coordinate=wgs84&callnative=0';
                }
                break;

            default:
                if (address) {
                    return 'https://www.google.com/maps/search/?api=1&zoom=12&query='+encodeURIComponent(address);
                } else {
                    return 'https://www.google.com/maps/search/?api=1&query='+lat+','+lng;
                }
        }
    });

    Handlebars.registerHelper("tabGridClass", function() {
        if (ThemeSettings.getInstance().getThemeName() === 'classic') {
            return 'col-sm-6';
        }
        return 'col-sm-6 col-md-4 col-lg-4';
    });
    
    /**
     * Checks if plugin is active
     *
     * @param String plugin
     */
    Handlebars.registerHelper('ifLocationHasAddress', function(location, options) {
        var addressAttributes = [
            'address1',
            'address2',
            'city',
            'zip',
            'phone'
        ];
        var result = false;
        _.each(addressAttributes, function (attribute) {
            if (location[attribute]) {
                //console.log(location[attribute]);
                result = true;
            }
        })
        
        if (result) {
            return options.fn(this);
        }
        return options.inverse(this);
    });

    /**
     * Get widget type string if exists
     */
    Handlebars.registerHelper('getWidgetType', function() {
        return Config.getInstance().getOption('widget_type', false);
    });

    /**
     * Check if menu item is visible
     */
    Handlebars.registerHelper('ifMenuItemVisible', function (route, options) {
        var menu = Config.getInstance().getOption('menu');
        var isVisible = false;
        jQuery.each(menu, function (i, menuData) {
            if (parseInt(menuData.is_visible) && menuData.route == route) {
                isVisible = true;
            }
        });
        if (isVisible) {
            return options.fn(this);
        } else {
            return options.inverse(this);
        }
    });

    Handlebars.registerHelper("lengthWithoutTags", function( txt ){
        if (typeof txt == "undefined" || txt == null) return 0;
        var regexp = /<[\/\w]+>/g
        return txt.replace(regexp, '').length;
    });

    Handlebars.registerHelper("encodeUrlForGoogleCalendar", function(string){
        if (string) {
            return string.replace('#', '%23');
        }
        return '';
    });

    Handlebars.registerHelper("packageLink", function(service, products, options) {
        if (!service) service = '';
        if (!products || !products.length) products = [];

        var serviceIds = _.isString(service) ? service : service.id;
        var productIds = _.isString(products) ? products : _.pluck(products, 'id').join(',');
        
        return '#packages' +
            (serviceIds ? '/services/' + serviceIds : '') + 
            (productIds ? '/products/' + productIds : '');
    });
});
